import styled from 'styled-components';
import { motion } from 'framer-motion';
import { isConstruction } from 'config';

export const Rect = styled(motion.rect)`
  fill: ${({ theme }) => theme.colors[isConstruction ? 'black' : 'grey6']};
  stroke-linecap: round;
`;
